'use client'

import { RefObject, createContext } from 'react'

import { CatalogState } from '@marketplace-web/domain/catalog-data'

import { CatalogAction } from './reducers/actionTypes'
import { initialState } from './catalog-initial-state'

type CatalogContextType = {
  state: CatalogState
  dispatch: React.Dispatch<CatalogAction>
  refs: CatalogRefs
}

type CatalogRefs = {
  dynamicFilterRequestVersion: RefObject<number> | undefined
}

const CatalogContext = createContext<CatalogContextType>({
  state: initialState,
  dispatch: () => null,
  refs: {
    dynamicFilterRequestVersion: undefined,
  },
})

export default CatalogContext
